import TextUser from './TextUser'

export default TextUser
